export const MAP_EMBED_URL =
  'https://www.google.com/maps/d/embed?mid=1hJKLQnok03vpbWouY7JqAaapqYc_BPc&ehbc=2E312F';

export const MAP_VIEWER_URL =
  'https://www.google.com/maps/d/viewer?mid=1hJKLQnok03vpbWouY7JqAaapqYc_BPc';

export const WELCOME_PARTY_MAPS_URL =
  'https://maps.app.goo.gl/BiiT2nNyjpPUwrNt5';

/** Scandic Spectrum hotel — wedding bus pickup. */
export const PICKUP_MAPS_URL =
  'https://maps.app.goo.gl/56GTwthD6LvPpx1v9';

/** Restaurant Herthadalen — wedding venue. */
export const VENUE_MAPS_URL =
  'https://maps.app.goo.gl/NpXnyFJZWg474Fw78';

/** Kalvebod Bølge — boat tour departure. */
export const KALVEBOD_BOLGE_MAPS_URL =
  'https://maps.app.goo.gl/kkJcszEGyF2oMkJ67';

/** Reffen Street Food — boat tour drop-off. */
export const REFFEN_MAPS_URL =
  'https://maps.app.goo.gl/WTTHBGGjwbNWCQdo6';
